import * as THREE from 'three';
import { DUST_FRAG, DUST_VERT, voidFogUniforms } from './shaders';

/** Parallax dust in the void — decoration only, never a task. */
export function createVoidDust() {
  const count = 90;
  const positions = new Float32Array(count * 3);
  const sizes = new Float32Array(count);
  const opacities = new Float32Array(count);
  for (let i = 0; i < count; i += 1) {
    // A slab: mostly behind the graph plane, a thin veil in front for parallax.
    const spread = 70;
    positions[i * 3] = (Math.random() - 0.5) * spread * 2;
    positions[i * 3 + 1] = (Math.random() - 0.5) * spread * 1.3;
    const front = Math.random() < 0.22;
    positions[i * 3 + 2] = front ? 3 + Math.random() * 14 : -4 - Math.random() ** 0.8 * 34;
    sizes[i] = (front ? 0.25 : 0.4) + Math.random() * (front ? 0.8 : 1.7);
    opacities[i] = 0.03 + Math.random() * (front ? 0.08 : 0.16);
  }
  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute('aSize', new THREE.BufferAttribute(sizes, 1));
  geometry.setAttribute('aOpacity', new THREE.BufferAttribute(opacities, 1));
  const material = new THREE.ShaderMaterial({
    uniforms: { ...voidFogUniforms(), uPixelRatio: { value: 1 } },
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    fog: false,
    vertexShader: DUST_VERT,
    fragmentShader: DUST_FRAG,
  });
  const points = new THREE.Points(geometry, material);
  points.frustumCulled = false;
  points.renderOrder = -10;
  return points;
}
